export default __webpack_public_path__ + "static/media/2505.56778b72.png";